import { render, staticRenderFns } from "./GiftPickerContents.vue?vue&type=template&id=02814f1f&"
import script from "./GiftPickerContents.vue?vue&type=script&lang=js&"
export * from "./GiftPickerContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports